//import { Dropdown } from 'react-native-element-dropdown';
import React, { useEffect, useState, useRef } from 'react';
import { View, Text, Pressable, StyleSheet, Button, Icon, Icon2 }  from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { loadTeamUserData, loadTeamCostDetail, loadTeamCostDetailProjections, loadTeamOpemCommitments, pNum, fNum, loadSummaryWIP, loadEquipmentData, loadTeamBillings, updateUserDataArray, loadSummaryWIPArray, loadGLAccount, loadJDEValues } from '../db/company';
import { dataSourceVersionAtom, isLiveVersionAtom, selectedVersionAtom, equipmentRatesAtom, selectedTeamAtom, dataSourceJobsAtom, overheadDataAtom, jobUserDataAtom, selectedWIPAtom, selectedVersionLockedAtom, projectCompleteAtom, ohPercentAtom } from '../store/company';
import moment from 'moment';
// import Icon2 from 'react-native-vector-icons/MaterialIcons';
// import Icon from 'react-native-vector-icons/Entypo';
import xlsx from 'xlsx';

const RunProjections = ({ photo, view, setJobRef, job }) => {
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [versionCleaned, setVersionCleaned] = useState([])
    const [versionDropdown, setVersionDropdown] = useState([])
    const [versionInfo, setVersionInfo] = useState({})
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
    const [jobs, setJobs] = useAtom(dataSourceJobsAtom);
    const [selectedWIP, setSelectedWIP] = useAtom(selectedWIPAtom);
    const [ohPercent, setOhPercent] = useAtom(ohPercentAtom)
    const [overheadData, setOverheadData] = useAtom(overheadDataAtom)
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom)
    const [filteredJobs, setFilteredJobs] = useState([])
    const [curBudget, setCurBudget] = useState({})
    const [fetchedAllJobUserData, setFetchedAllJobUserData] = useState(false)
    const [startDates, setStartDates] = useState({})
    const [completionDates, setCompletionDates] = useState({})
    const [mechCompleteDates, setMechCompleteDates] = useState({})
    const [physicalComplete, setPhysicalComplete] = useState({})
    const [actualCost, setActualCost] = useState({})
    const [actualOverhead, setActualOverhead] = useState({})
    const [openCommitments, setOpenCommitments] = useState({})
    const [ETC, setETC] = useState({})
    const [EAC, setEAC] = useState({})
    const [jobProfit, setJobProfit] = useState({})
    const [jobProfitPerc, setJobProfitPerc] = useState({})
    const [jobPrevWIP, setJobPrevWIP] = useState({})
    //const [equipRates, setEquipRates] = useState({})
    const [equipmentUserData, setEquipmentUserData] = useState({})
    const [labor, setLabor] = useState({})
    const [laborCostType, setLaborCostType] = useState({})
    const [equipmentCostType, setEquipmentCostType] = useState({})
    const [equipmentPhased, setEquipmentPhased] = useState({})
    const [materials, setMaterials] = useState({})
    const [rentals, setRentals] = useState({})
    const [subcontractors, setSubcontractors] = useState({})
    const [other, setOther] = useState({})
    const [contingency, setContingency] = useState({})
    const [incentive, setIncentive] = useState({})
    const [total, setTotal] = useState({})
    const [projectComplete, setProjectComplete] = useAtom(projectCompleteAtom)
    const [grossMargin, setGrossMargin] = useState({})
    const [grossMarginPerc, setGrossMarginPerc] = useState({})
    const [backlog, setBacklog] = useState({})

    const [prevContingency, setPrevContingency] = useState({})
    const [costPercent, setCostPercent] = useState({})
    const [actualHours, setActualHours] = useState({})
    const [hoursETC, setHoursETC] = useState({})
    const [mostRecentBill, setMostRecentBill] = useState({})
    const [earnedRevenue, setEarnedRevenue] = useState({})
    const [billings, setBillings] = useState({})
    const [overUnderBilled, setOverUnderBilled] = useState({})
    const [remainingToBill, setRemainingToBill] = useState({})
    const [expandCosts, setExpandCosts] = useState(false)
    const [expandBills, setExpandBills] = useState(false)
    const [earnedRevenueRows, setEarnedRevenueRows] = useState({})
    const [etcOverhead, setETCOverhead] = useState({})
    const [backlogFiltered, setBacklogFiltered] = useState([])
    const [backlogFilteredImage, setBacklogFilteredImage] = useState([])
    const sectionRefs = useRef([])
    const [highlightedJob, setHighlightedJob] = useState({})
    const [totalBudget, setTotalBudget] = useState(0)
    const [totalEAC, setTotalEAC] = useState(0)
    const [totalJobProfit, setTotalJobProfit] = useState(0)
    const [totalJobProfitPercent, setTotalJobProfitPercent] = useState(0)
    const [totalGrossMargin, setTotalGrossMargin] = useState(0)
    const [totalGrossMarginPercent, setTotalGrossMarginPercent] = useState(0)
    const [totalContingency, setTotalContingency] = useState(0)
    const [totalPrevContingency, setTotalPrevContingency] = useState(0)
    const [totalBacklog, setTotalBacklog] = useState(0)
    const [totalJobPerformanceChange, setTotalJobPerformanceChange] = useState(0)
    const [totalPrevWIP, setTotalPrevWIP] = useState(0)
    const [totalOverUnderBilled, setTotalOverUnderBilled] = useState(0)
    const [adminButton, setAdminButton] = useState(false)

    const [etcPieces, setEtcPieces] = useState({})
    const [phaseEtcPieces, setPhaseEtcPieces] = useState({})
    const [laborPieces, setLaborPieces] = useState({})
    const [laborPhasedPieces, setLaborPhasedPieces] = useState({})
    const [equipmentPieces, setEquipmentPieces] = useState({})
    const [equipmentPhasedPieces, setEquipmentPhasedPieces] = useState({})
    const [openCommitmentsPieces, setOpenCommitmentsPieces] = useState({})
    const [projectionCost, setProjectionCost] = useState([])
    const [contingencyPieces, setContingencyPieces] = useState({})
    const [projectionRows, setProjectionRows] = useState([])
    const [excelProjectionRows, setExcelProjectionRows] = useState([])
    const fileInput = useRef(null);
    const [file, setFile] = useState(null);


    const [eacLabor, setEACLabor] = useState({})
    const [eacEquipment, setEACEquipment] = useState({})
    const [eacMaterials, setEACMaterials] = useState({})
    const [eacRentals, setEACRentals] = useState({})
    const [eacSubcontractors, setEACSubcontractors] = useState({})
    const [eacOther, setEACOther] = useState({})
    const [eacContingency, setEACContingency] = useState({})
    const [photoLocal, setPhotoLocal] = useState(photo)
    const [equipRates, setEquipRates] = useState({})
    const [projectionDetails, setProjectionDetails] = useState([])
    const [failedUploads, setFailedUploads] = useState([])
    const [glCombinations, setGLCombinations] = useState({})
    const [notFoundList, setNotFoundList] = useState([])
    const [neededProjections, setNeededProjections] = useState([])
    const [jdeValues, setJDEValues] = useState([])
    const [glValues, setGlValues] = useState([])
    const [showNotFoundList, setShowNotFoundList] = useState(false)
    const [notFoundListCount, setNotFoundListCount] = useState(0)
    const [compareList, setCompareList] = useState([])
    const [highLevelCompareList, setHighLevelCompareList] = useState([])

    const findCombinations = async (data = null) => {
        const combinations = {}
        const loopValues = data ? data : glValues
        loopValues.forEach((d) => {
            if (!combinations[d.BU_ID]) {
                combinations[d.BU_ID] = {}
            }

            if (!combinations[d.BU_ID][d.Object_Account_ID]) {
                combinations[d.BU_ID][d.Object_Account_ID] = {}
            }

            if (!combinations[d.BU_ID][d.Object_Account_ID][d.Subsidiary]) {
                combinations[d.BU_ID][d.Object_Account_ID][d.Subsidiary] = true
            }
        })
        console.log('combinations', combinations)
        const notFound = []
        projectionRows.forEach((row) => {
            if (row.costType != '60900' && !combinations[row.jobId]?.[row.costType]?.[row.phaseCode]) {
                notFound.push(row)
            }
        })
        //console.log('not found', notFound)
        setNotFoundListCount(notFound.length)
        setNotFoundList(notFound)
        setGLCombinations(combinations)
    }

    const handlePhaseChange = (index, newPhase) => {
        setProjectionList((prev) => {
            const updatedList = [...prev];
            updatedList[index] = {
                ...updatedList[index],
                phaseCode: newPhase,
            };
            return updatedList;
        });
    }

    useEffect(() => {
        if (glValues?.length && projectionRows.length) {
            findCombinations()
        }
    }, [glValues, projectionRows])

    useEffect(() => {
        if (filteredJobs.length) {
            const jobIds = filteredJobs.map(j => j.BU_ID)

            // fetch('http://localhost:3000/projections', {
            //     method: 'GET',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     }
            // })
            //     .then(response => response.json())
            //     .then(data => {
            //         console.log('Projections data:', data?.data.length);
            //         setJDEValues(data?.data);

            //     })
            //     .catch(error => {
            //         console.error('Error fetching projections:', error);
            //     });


            // fetch('http://localhost:3000/projectionsTwo', {
            //     method: 'GET',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     }
            // })
            //     .then(response => response.json())
            //     .then(data => {
            //         console.log('Projections data:', data?.data.length);
            //         setJDEValues(data?.data);

            //     })
            //     .catch(error => {
            //         console.error('Error fetching projections:', error);
            //     });

            // loadJDEValues({ ids: jobIds }).then((data) => {
            //     setJDEValues(data?.data)
            // })
            loadGLAccount({ ids: jobIds }).then((data) => {
                setGlValues(data?.data)
            })
        }
    }, [filteredJobs])

    useEffect(() => {
        const fJDE = (nStr) => {
            let a = ''
            numberStr = nStr ? nStr + '' : ''
            if (!numberStr) return 0; // Handle empty input

            if (numberStr.length === 1) {
                a = "0.0" + numberStr; // Convert "7" to "0.07"
            } else if (numberStr.length === 2) {
                a = "0." + numberStr; // Convert "99" to "0.99"
            } else if (numberStr) {
                a = numberStr.slice(0, -2) + '.' + numberStr.slice(-2);
            }
            return pNum(a)
        }

        //if (jdeValues?.length) {
        const currentValues = {}
        jdeValues && jdeValues?.forEach((d) => {
            const jobId = d.Job_ID.trim();
            const costType = d.Cost_Type.trim();
            const phaseCode = d.Cost_Code.trim();
            if (!currentValues[jobId]) {
                currentValues[jobId] = {}
            }
            if (!currentValues[jobId][costType]) {
                currentValues[jobId][costType] = {}
            }
            if (!currentValues[jobId][costType][phaseCode]) {
                currentValues[jobId][costType][phaseCode] = fJDE(d.PRDP) + fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3) + fJDE(d.PRD4) //+ fJDE(d.PRD5) + fJDE(d.PRD6) + fJDE(d.PRD7) + fJDE(d.PRD8) + fJDE(d.PRD9)
                //d.PRD1 + d.PRD2 + d.PRD3 + d.PRD4 + d.PRD5 + d.PRD6 + d.PRD7 + d.PRD8 + d.PRD9
                //fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3) + fJDE(d.PRD4) + fJDE(d.PRD5) + fJDE(d.PRD6) + fJDE(d.PRD7) + fJDE(d.PRD8) + fJDE(d.PRD9)
            } else {
                currentValues[jobId][costType][phaseCode] = fJDE(currentValues[jobId][costType][phaseCode]) + fJDE(d.PRDP) + fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3) + fJDE(d.PRD4) //+ fJDE(d.PRD5) + fJDE(d.PRD6) + fJDE(d.PRD7) + fJDE(d.PRD8) + fJDE(d.PRD9)
            }
        })
        console.log('current values', currentValues)
        const discrepancies = [];
        // const projectionRowsCopy = [{
        //     jobId: '10111005',
        //     costType: '52200',
        //     phaseCode: '195101',
        //     value: '54000'
        // }, ...projectionRows]

        projectionRows.forEach((row, index) => {
            const { jobId, costType, phaseCode, value } = row;
            const currentValue = currentValues[jobId]?.[costType]?.[phaseCode];
            if (index == 500) console.log('row 1', currentValue)

            if (value == 0 && !currentValue) {
                //console.log('not found add', row)
                //if (index == 0) console.log('row 2', currentValue)
                //discrepancies.push(row);
            } else if (!currentValue || currentValue != value) {
                //if (index == 0) console.log('row 3', currentValue)
                discrepancies.push(row);
            }
        });

        const newRows = [];
        const compareListLocal = [];
        Object.keys(currentValues).forEach((jobId) => {
            Object.keys(currentValues[jobId]).forEach((costType) => {
                Object.keys(currentValues[jobId][costType]).forEach((phaseCode) => {
                    const row = {
                        jobId,
                        costType,
                        phaseCode,
                        value: pNum(currentValues[jobId][costType][phaseCode])
                    }

                    const exists = projectionRows.find(row => row.jobId === jobId && row.costType === costType && row.phaseCode === phaseCode);
                    if (exists) {
                        row.projectionValue = exists?.value
                    }
                    if (!exists) {
                        // if (pNum(currentValues[jobId][costType][phaseCode]) == 9.09) {
                        //     console.log('9.09 row', row)
                        // } else {
                        //     console.log('not 9.09 row', row)
                        // }
                        const newRow = {
                            jobId,
                            costType,
                            phaseCode,
                            value: '0'
                        };
                        discrepancies.push(newRow);
                        newRows.push(newRow);
                    }
                    compareListLocal.push(row)
                });
            });
        });

        projectionRows.forEach((row) => {
            const exists = compareListLocal.find(compareRow =>
                compareRow.jobId === row.jobId &&
                compareRow.costType === row.costType &&
                compareRow.phaseCode === row.phaseCode
            );
            if (!exists) {
                compareListLocal.push({
                    jobId: row.jobId,
                    costType: row.costType,
                    phaseCode: row.phaseCode,
                    value: '',
                    projectionValue: row.value
                })
            }
        });

        //console.log('new rows', newRows)
        //console.log('compare list', compareListLocal)
        setCompareList(compareListLocal.sort((a, b) => {
            if (a.costType > b.costType) {
                return 1
            }
            if (a.costType < b.costType) {
                return -1
            }
        }))


        const highLevelCompare = [];
        const addToHighLevelCompare = (jobId, costType, phaseCode, value, projectionValue) => {
            const existingEntry = highLevelCompare.find(entry => entry.jobId === jobId);

            if (existingEntry) {
                if (phaseCode == '101101') {
                    existingEntry.contingency += value;
                    existingEntry.contingencyProjection += projectionValue;
                } else if (costType.startsWith('51')) {
                    existingEntry.labor += value;
                    if (jobId == '50424040') console.log('labor', projectionValue)
                    existingEntry.laborProjection += projectionValue;
                } else if (costType.startsWith('52')) {
                    existingEntry.equipment += value;
                    existingEntry.equipmentProjection += projectionValue;
                } else if (costType.startsWith('53')) {
                    existingEntry.materials += value;
                    existingEntry.materialsProjection += projectionValue;
                } else if (costType.startsWith('54')) {
                    existingEntry.subcontractors += value;
                    existingEntry.subcontractorsProjection += projectionValue;
                } else if (costType.startsWith('55') || costType.startsWith('56') || costType.startsWith('57')) {
                    existingEntry.other += value;
                    existingEntry.otherProjection += projectionValue;
                }
            } else {
                highLevelCompare.push({
                    jobId,
                    labor: costType.startsWith('51') && phaseCode != '101101' ? value : 0,
                    equipment: costType.startsWith('52') && phaseCode != '101101' ? value : 0,
                    materials: costType.startsWith('53') && phaseCode != '101101' ? value : 0,
                    subcontractors: costType.startsWith('54') && phaseCode != '101101' ? value : 0,
                    other: (costType.startsWith('55') || costType.startsWith('56') || costType.startsWith('57')) && phaseCode != '101101' ? value : 0,
                    laborProjection: costType.startsWith('51') && phaseCode != '101101' ? projectionValue : 0,
                    equipmentProjection: costType.startsWith('52') && phaseCode != '101101' ? projectionValue : 0,
                    materialsProjection: costType.startsWith('53') && phaseCode != '101101' ? projectionValue : 0,
                    subcontractorsProjection: costType.startsWith('54') && phaseCode != '101101' ? projectionValue : 0,
                    otherProjection: (costType.startsWith('55') || costType.startsWith('56') || costType.startsWith('57')) && phaseCode != '101101' ? projectionValue : 0,
                    contingency: phaseCode == '101101' ? value : 0,
                    contingencyProjection: phaseCode == '101101' ? projectionValue : 0,
                });
            }
        };

        compareListLocal.forEach(row => {
            addToHighLevelCompare(row.jobId, row.costType, row.phaseCode, pNum(row.value), pNum(row.projectionValue));
        });

        //console.log('High Level Compare:', discrepancies);
        setHighLevelCompareList(highLevelCompare);
        setNeededProjections(discrepancies)
        //}
    }, [jdeValues, projectionRows])

    const exportCurrentValues = () => {

        console.log('Discrepancies:', projectionRows);
        const worksheet = xlsx.utils.json_to_sheet(projectionRows);
        const workbook = xlsx.utils.book_new();

        xlsx.utils.book_append_sheet(workbook, worksheet, "Job Cost Data");

        // Create Excel file and trigger download
        xlsx.writeFile(workbook, "ProjectionsJulyWIP.xlsx");
    }

    const uploadUserData = (file = null) => {
        console.log('upload excel', file)
        if (file) {
            const reader = new FileReader();
            console.log('here')
            reader.onload = (e) => {
                console.log('reader')
                const data = new Uint8Array(e.target.result);
                const workbook = xlsx.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const parsedData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });

                // Assuming the first row contains column headers
                // You can customize this according to your Excel file structure

                const desiredColumns = ['jobId', 'value', 'phaseCode', 'costType'];
                const columnIndexMap = {};
                const parsedColumns = parsedData[0];
                desiredColumns.forEach((col) => {
                    const index = parsedColumns.indexOf(col);
                    if (index !== -1) {
                        columnIndexMap[col] = index;
                    }
                });

                const extractedData = parsedData.slice(1).map((row) => {
                    const rowData = {};
                    desiredColumns.forEach((col) => {
                        rowData[col] = row[columnIndexMap[col]];
                    });
                    return rowData;
                });

                console.log('extracted data', extractedData);
                setExcelProjectionRows(extractedData);
            }
            reader.readAsArrayBuffer(file);
        }
    }

    const fileSelectedHandler = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        uploadUserData(selectedFile);
    }

    // Function to Export to Excel
    const exportToExcel = () => {
        if (!projectionRows.length) {
            alert("No data to export.");
            return;
        }

        const worksheet = xlsx.utils.json_to_sheet(projectionRows);
        const workbook = xlsx.utils.book_new();

        xlsx.utils.book_append_sheet(workbook, worksheet, "Job Cost Data");

        // Create Excel file and trigger download
        xlsx.writeFile(workbook, "ProjectionsJanWIP.xlsx");
    };

    const createExcel = () => {
        const rows = []
        filteredJobs.forEach((job) => {
            rows.push({
                "Job Number": job.BU_ID,
                "Work Type": job.Cat_Code_BU_08 == 'TMN' ? 'NTE' : job.Cat_Code_BU_08,
                "Job Name": job.BU_Description,
                "Client": job.AR_AB_Name,
                "Project Manager": "",
                "Labor": labor[job.BU_ID],
                "Equipment": equipmentCostType[job.BU_ID] + equipmentPhased[job.BU_ID],
                "Materials": materials[job.BU_ID],
                "Rentals": rentals[job.BU_ID],
                "Subcontractors": subcontractors[job.BU_ID],
                "Other": other[job.BU_ID],
                "Contingency": contingency[job.BU_ID],
                "Incentive": incentive[job.BU_ID],
                "Total": total[job.BU_ID],
                'Total Open Commitments': openCommitments[job.BU_ID],
                "Actual Cost": actualCost[job.BU_ID],
                "Cur Budget Revenue": curBudget[job.BU_ID],
                "Est Cost At Completion": EAC[job.BU_ID],
                "Forecasted Job Profit": jobProfit[job.BU_ID],
                "Job Profit": jobProfitPerc[job.BU_ID],
                "Overhead": pNum(actualOverhead[job.BU_ID]) + pNum(etcOverhead[job.BU_ID]),
                "Gross Margin": grossMargin[job.BU_ID],
                "Gross Margin %": grossMarginPerc[job.BU_ID],
                "Current Contingency": contingency[job.BU_ID],
                "Prev WIP Contingency": prevContingency[job.BU_ID],
                "Backlog": backlog[job.BU_ID],
                "Costs": costPercent[job.BU_ID],
                "Labor Hours": pNum(actualHours[job.BU_ID]) / (pNum(actualHours[job.BU_ID]) + pNum(hoursETC[job.BU_ID])),
                "Physical": physicalComplete[job.BU_ID],
                "Last Billing": mostRecentBill[job.BU_ID],
                "Earned Revenue": earnedRevenue[job.BU_ID],
                "Billings": billings[job.BU_ID],
                "Remaining to Bill": remainingToBill[job.BU_ID],
                "Over/Under Billed": overUnderBilled[job.BU_ID],
                "Job Performance Change": jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]), 1) : '',
                "Prev. WIP": jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobPrevWIP[job.BU_ID]?.total), 1) : '',
                "Prev. WIP %": jobPrevWIP[job.BU_ID]?.percent ? fNum(jobPrevWIP[job.BU_ID]?.percent) + '%' : '',
                "Prev. WIP Gain/Fade $": jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total)) : '',
                "Prev. WIP Gain/Fade %": jobProfitPerc[job.BU_ID] && jobPrevWIP[job.BU_ID]?.percent ? fNum(pNum(jobProfitPerc[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.percent)) + '%' : '',
                "Start Date (Actual)": startDates[job.BU_ID],
                "Completion Date (Forecasted)": completionDates[job.BU_ID],
                "Mechanically Complete Date": mechCompleteDates[job.BU_ID]
            })
        })

        const ws = xlsx.utils.json_to_sheet(rows);




        const wsColumns = [
            { wpx: 90 },  // Job Number width
            { wpx: 90 },  // Work Type width
            { wpx: 160 }, // Job Name width
            { wpx: 100 }, // Client width
            { wpx: 100 }, // Project Manager width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Cur Budget Revenue width
            { wpx: 100 }, // Est Cost At Completion width
            { wpx: 100 }, // Forecasted Job Profit width
            { wpx: 100 }, // Job Profit width
            { wpx: 100 }, // Gross Margin width
            { wpx: 100 }, // Gross Margin % width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Current Contingency width
            { wpx: 100 }, // Prev WIP Contingency width
            { wpx: 100 }, // Backlog width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Costs width
            { wpx: 100 }, // Labor Hours width
            { wpx: 100 }, // Physical width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Last Billing width
            { wpx: 100 }, // Earned Revenue width
            { wpx: 100 }, // Billings width
            { wpx: 100 }, // Remaining to Bill width
            { wpx: 100 }, // Over/Under Billed width
            { wpx: 20 },  // Spacer or additional width as needed
            { wpx: 100 }, // Job Performance Change width
            { wpx: 100 }, // Prev. WIP width
            { wpx: 100 }, // Prev. WIP Gain/Fade $ width
            { wpx: 100 }, // Prev. WIP Gain/Fade % width
            { wpx: 100 }, // Start Date (Actual) width
            { wpx: 100 }, // Completion Date (Forecasted) width
            { wpx: 100 }, // Mechanically Complete Date width
        ];
        ws['!cols'] = wsColumns;

        // Create a new workbook and add the worksheet
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'summary');

        // Write the workbook to a file
        xlsx.writeFile(wb, 'summary.xlsx');
    }

    useEffect(() => {
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const overUnderBilled = {}
        const remainingToBill = {}
        jobIds.forEach((job) => {
            overUnderBilled[job] = pNum(billings[job]) - pNum(earnedRevenue[job])
            remainingToBill[job] = pNum(curBudget[job]) - pNum(billings[job])
        })
        setOverUnderBilled(overUnderBilled)
        setRemainingToBill(remainingToBill)
    }, [billings, earnedRevenue, curBudget, filteredJobs])

    useEffect(() => {
        if (selectedTeam) {
            console.log('selected team changed', selectedTeam, overheadData)
            setOhPercent(overheadData[selectedTeam] ? overheadData[selectedTeam] : '')
        }
    }, [selectedTeam, overheadData])

    useEffect(() => {
        const earnedRevenue = {}
        //console.log('earned revenue rows', earnedRevenueRows)
        earnedRevenueRows && Object.keys(earnedRevenueRows).forEach((job) => {
            earnedRevenue[job] = isNaN(pNum(earnedRevenueRows[job])) ? 0 : pNum(earnedRevenueRows[job]) * -1
        })


        const ohETC = {}
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const ohTeamPercent = {}
        filteredJobs.forEach(job => {
            ohTeamPercent[job.BU_ID] = overheadData[job.Cat_Code_BU_27] ? overheadData[job.Cat_Code_BU_27] : ''
        })

        jobIds.forEach((job) => {
            const ohPer = ohTeamPercent[job] ? pNum(ohTeamPercent[job]) : 0
            const oh = curBudget[job] ? earnedRevenueRows[job] ? (pNum(curBudget[job]) + pNum(earnedRevenueRows[job])) * ohPer / 100 : pNum(curBudget[job]) * ohPer / 100 : ''
            const ohFormatted = oh < 0 ? '' : isNaN(pNum(oh)) ? 0 : pNum(oh)
            //console.log('oh per', job, ohPer, pNum(earnedRevenueRows[job]), pNum(curBudget[job]), oh)
            //if (job == '10124011')console.log('oh >>', job, curBudget[job], earnedRevenue[job], ohPer, oh)
            ohETC[job] = ohFormatted
        })
        //console.log('overhead etc pieces', ohTeamPercent, curBudget, earnedRevenueRows)
        //console.log('oh etc', ohETC)
        //if wrong check wip date for earned rev
        setETCOverhead(ohETC)
    }, [earnedRevenueRows, overheadData, curBudget])

    useEffect(() => {
        //console.log('here in not loading')
        if (!fetchedAllJobUserData && filteredJobs?.length > 0) {
            //console.log('here in loading')
            setFetchedAllJobUserData(true)
            const chOrValues = {}
            const dayZeroValues = {}
            const mechanicallyCompleteDates = {}
            const startDates = {}
            const completionDates = {}
            const physicalComplete = {}

            const jobIds = filteredJobs.map(j => j.BU_ID)
            const phasedEquipment = {}
            const phasedLabor = {}
            const laborValues = {}
            const equipmentValues = {}
            const contingData = {}
            const etcValues = {}
            const etcValuesPieces = {}
            const phaseEtcValues = {}
            const phaseEtcValuesPieces = {}
            const highlightedJob = {}
            const w = {}

            loadEquipmentData({ forecastGuid: selectedVersion }).then((data) => {
                const rData = {}
                data?.data.forEach((d) => {
                    if (d?.Forecast_Tab === 'Equipment') {
                        if (rData[d?.Forecast_Row_ID]) {
                            rData[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else {
                            rData[d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        }
                    }
                })

                const rates = {}
                Object.values(rData).forEach((row, index) => {
                    rates[row['Equipment Tier']] = row['Current Hourly Billing Rate']
                })
                console.log('rates', rates)
                setEquipRates(rates)
            })

            //console.log('etc values', etcValues);

            const chunkSize = 10
            const jobChunks = []
            for (let i = 0; i < jobIds.length; i += chunkSize) {
                jobChunks.push(jobIds.slice(i, i + chunkSize))
            }

            Promise.all(jobChunks.map(chunk => loadTeamUserData({ ids: chunk, forecastGuid: selectedVersion }))).then((results) => {
                const data = results.flatMap(r => r?.data || [])
                //console.log('user data', data);
                data.forEach((d) => {
                    if (d?.Forecast_Tab === 'Change Order') {
                        if (chOrValues[d?.BU_ID]) {
                            chOrValues[d?.BU_ID][d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                        } else {
                            chOrValues[d?.BU_ID] = {
                                [d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID]: { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Day Zero Budget') {
                        if (dayZeroValues[d?.BU_ID] && dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID]) {
                            dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else if (dayZeroValues[d?.BU_ID]) {
                            dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            dayZeroValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    //if (d?.Forecast_Tab === 'All' || d?.Forecast_Tab === 'Forecast' || d?.Forecast_Tab === 'Set Dates') {
                        if (d?.Forecast_Field_Name === 'mechanicallyComplete') {
                            mechanicallyCompleteDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                        } else if (d?.Forecast_Field_Name === 'startDateActual') {
                            startDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                        } else if (d?.Forecast_Field_Name === 'completionDateForecast') {
                            completionDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                        } else if (d?.Forecast_Field_Name === 'physicalComplete') {
                            physicalComplete[d?.BU_ID] = d?.Forecast_Value
                        }
                    //}

                    if (d?.Forecast_Tab === 'Burn Tool Labor') {
                        if (laborValues[d?.BU_ID]) {
                            laborValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            laborValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Equipment') {
                        if (equipmentValues[d?.BU_ID]) {
                            equipmentValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            equipmentValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Equipment Phased') {
                        if (phasedEquipment[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            phasedEquipment[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else if (phasedEquipment[d?.BU_ID]) {
                            phasedEquipment[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else {
                            phasedEquipment[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    ...d
                                }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Labor Phased') {
                        if (phasedLabor[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            phasedLabor[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else if (phasedLabor[d?.BU_ID]) {
                            phasedLabor[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else {
                            phasedLabor[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    ...d
                                }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Contingency') {
                        if (contingData[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            contingData[d?.BU_ID][d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else if (contingData[d?.BU_ID]) {
                            contingData[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        } else {
                            contingData[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    [d.Forecast_Field_Name]: d.Forecast_Value
                                }
                            }
                        }
                    }

                    if (d?.Cost_Type && d?.Forecast_Field_Name == 'etc' && (!d?.Cost_Code || d?.Cost_Code != '101101')) {
                        if (d?.Cost_Type == 'undefined') {
                            d.Cost_Type = '100105'
                        }
                        if (etcValues[d?.BU_ID]?.[d?.Cost_Type]) {
                            etcValues[d?.BU_ID][d?.Cost_Type] = etcValues[d?.BU_ID][d?.Cost_Type] + pNum(d?.Value_Amount)
                        } else if (etcValues[d?.BU_ID]) {
                            etcValues[d?.BU_ID][d?.Cost_Type] = pNum(d?.Value_Amount)
                        } else {
                            etcValues[d?.BU_ID] = {
                                [d?.Cost_Type]: pNum(d?.Value_Amount),
                            }
                        }

                        if (!d?.Cost_Code || d?.Code_Code?.includes('^')) d.Cost_Code = '100105'
                        if (!etcValuesPieces[d?.BU_ID]) {
                            etcValuesPieces[d?.BU_ID] = {}
                        }
                        if (!etcValuesPieces[d?.BU_ID][d?.Cost_Type]) {
                            etcValuesPieces[d?.BU_ID][d?.Cost_Type] = {}
                        }
                        if (!etcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code]) {
                            etcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = 0
                        }
                        etcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = etcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] + pNum(d?.Value_Amount)
                    }

                    if (d?.Cost_Type && d?.Forecast_Field_Name == 'etc' && (!d?.Cost_Code || d?.Cost_Code != '101101')) {
                        if (!d?.Cost_Code) {
                            d.Cost_Code = '100105'
                        }
                        if (phaseEtcValues[d?.BU_ID]?.[d?.Cost_Type]?.[d?.Cost_Code]) {
                            phaseEtcValues[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = phaseEtcValues[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] + pNum(d?.Value_Amount)
                        } else if (phaseEtcValues[d?.BU_ID]?.[d?.Cost_Type]) {
                            phaseEtcValues[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = pNum(d?.Value_Amount)
                        } else if (phaseEtcValues[d?.BU_ID]?.[d?.Cost_Type]) {
                            phaseEtcValues[d?.BU_ID][d?.Cost_Type] = {}
                            phaseEtcValues[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = pNum(d?.Value_Amount)
                        } else {
                            phaseEtcValues[d?.BU_ID] = {}
                            phaseEtcValues[d?.BU_ID][d?.Cost_Type] = {}
                            phaseEtcValues[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = pNum(d?.Value_Amount)
                        }


                        if (!phaseEtcValuesPieces[d?.BU_ID]) {
                            phaseEtcValuesPieces[d?.BU_ID] = {}
                        }
                        if (!phaseEtcValuesPieces[d?.BU_ID][d?.Cost_Type]) {
                            phaseEtcValuesPieces[d?.BU_ID][d?.Cost_Type] = {}
                        }
                        if (!phaseEtcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code]) {
                            phaseEtcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = 0
                        }
                        phaseEtcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] = phaseEtcValuesPieces[d?.BU_ID][d?.Cost_Type][d?.Cost_Code] + pNum(d?.Value_Amount)
                    }


                    if (d?.Forecast_Tab === 'Summary' && d?.Forecast_Field_Name === 'highlighted') {
                        highlightedJob[d?.BU_ID] = d?.Value_Amount
                    }
                })
                setEquipmentUserData(phasedEquipment)
                setHighlightedJob(highlightedJob)

                let etcLabor = {}
                let etcLaborTwo = {}
                let etcIncentive = {}
                let etcEquipment = {}
                let etcMaterials = {}
                let etcRentals = {}
                let etcSubcontractors = {}
                let etcOther = {}
                let etcContingency = {}
                let totalContingency = 0
                let etcTotal = {}
                let hours = {}


                let equipmentCostTypePieces = {}
                let laborCostTypePieces = {}
                let regularTimePieces = {}
                let regularHoursLaborPieces = {}
                let laborPieces = {}
                let rentalPieces = {}
                let materialsPieces = {}
                let subcontractorPieces = {}
                let otherPieces = {}


                //console.log('etcvalue', etcValues);
                //console.log('labor values', laborValues, 'equipment values', equipmentValues);
                //console.log('phased labor', phasedLabor, 'phased equipment', phasedEquipment);

                //console.log('equipmentValues', equipmentValues);
                //console.log('laborValues', laborValues);
                // Fall back to Planned_Complete_Date if no user-saved forecast date
                filteredJobs.forEach((job) => {
                    if (!completionDates[job.BU_ID] && job.Planned_Complete_Date) {
                        completionDates[job.BU_ID] = moment(job.Planned_Complete_Date).format('M/D/YYYY')
                    }
                })
                const contingencyPieces = {}
                const totalCost = {}
                jobIds.forEach((job) => {
                    let regularTimeCostType = 0
                    let equipmentCostType = 0
                    let regularTime = 0
                    let regularHours = 0
                    let etc = 0
                    let regularTimeCostTypePieces = {}
                    let regularHourPieces = {}
                    let etcPieces = {}
                    const pC = completionDates[job]


                    equipmentValues[job] && Object.keys(equipmentValues[job]).forEach((key) => {
                        //if (job == '54025037') console.log('in add together', equipmentValues[job]?.[key], key.length == 10 && moment(key).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).endOf('week').isAfter(key))
                        if (key.length == 10 && moment(key).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).endOf('week').isAfter(key)) {
                            const row = equipmentValues[job]?.[key]
                            equipmentCostType = equipmentCostType + ((isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours)))
                            const costCode = row.Cost_Code && row.Cost_Code != 'undefined' ? row.Cost_Code : '100105'
                            if (!equipmentCostTypePieces[job]) {
                                equipmentCostTypePieces[job] = {}
                            }
                            if (!equipmentCostTypePieces[job][row.Cost_Type]) {
                                equipmentCostTypePieces[job][row.Cost_Type] = {}
                            }
                            if (!equipmentCostTypePieces[job][row.Cost_Type][costCode]) {
                                equipmentCostTypePieces[job][row.Cost_Type][costCode] = 0
                            }
                            equipmentCostTypePieces[job][row.Cost_Type][costCode] = equipmentCostTypePieces[job][row.Cost_Type][costCode] + (isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours))
                            //if (job == '54024085') console.log('85 equipmentValues', equipmentCostType, row.burnPerHour, row.numOfWorkers, row.hoursPerWeek)
                        }
                        //totaleETC = equipmentCost
                    })

                    //console.log(laborValues[job]);

                    laborValues[job] && Object.values(laborValues[job]).forEach((row) => {
                        if (row) {
                            const costCode = row.Cost_Code && row.Cost_Code != 'undefined' ? row.Cost_Code : '100105'
                            const week = row?.Forecast_Row_ID ? row.Forecast_Row_ID.split('*')[0] : ''
                            const pC = completionDates[job]
                            if(job == '54024090') console.log('90 laborValues', week, moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')), moment(pC).isAfter(week), row)

                            if (week && moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).isAfter(week)) {
                                if(job == '54024090') console.log('inside 90 laborValues', week, pC, laborValues[job])
                                if (!laborCostTypePieces[job]) {
                                    laborCostTypePieces[job] = {
                                        '51100': {
                                            [costCode]: 0
                                        }
                                    }
                                }
                                if (!laborCostTypePieces[job]['51100'][costCode]) {
                                    laborCostTypePieces[job]['51100'][costCode] = 0
                                }
                                laborCostTypePieces[job]['51100'][costCode] = laborCostTypePieces[job]['51100'][costCode] + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                                regularTimeCostType = regularTimeCostType + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                                regularHours = regularHours + (!isNaN(pNum(row.Number_Hours)) && !isNaN(pNum(row.Number_Units)) ? pNum(row.Number_Hours) * pNum(row.Number_Units) : 0)
                            }
                        }
                    })


                    phasedLabor[job] && Object.keys(phasedLabor[job]).forEach((row) => {
                        const weekRow = row.includes('=')
                        const week = row.split('=')[1]
                        const phase = row.split('=')[0]
                        const pC = completionDates[job]
                        const phaseDetails = phase ? phasedLabor[job][phase] : {}
                        const withinProject = moment(week).isAfter(moment(versionInfo.Version_Start_DateTime).startOf('week')) && moment(week).isBefore(moment(pC).endOf('week'))
                        const withinStartStop = true//moment(week).isAfter(moment(phaseDetails?.startDate).startOf('week')) && moment(week).isBefore(moment(phaseDetails?.endDate).endOf('week'))
                        const h = phasedLabor[job][row]?.Number_Hours ? phasedLabor[job][row].Number_Hours : 0
                        const bR = phasedLabor[job][row]?.Rate ? phasedLabor[job][row].Rate : 0
                        const cS = phasedLabor[job][row]?.Number_Units ? phasedLabor[job][row].Number_Units : 0
                        //if (job == '54025036' && h) { console.log('phased labor check', weekRow, phasedLabor[job][row], h, bR, cS, withinProject, withinStartStop) }
                        if (weekRow && phasedLabor[job][row] && h && bR && cS && withinProject && withinStartStop) {
                            if (!regularTimePieces[job]) {
                                regularTimePieces[job] = {
                                    ['51100']: {
                                        [phase]: 0
                                    }
                                }
                            }
                            if (!regularTimePieces[job]['51100'][phase]) {
                                regularTimePieces[job]['51100'][phase] = 0
                            }

                            regularTimePieces[job]['51100'][phase] = regularTimePieces[job]['51100'][phase] + (!isNaN(pNum(bR)) && !isNaN(pNum(h)) && !isNaN(pNum(cS)) ? pNum(bR) * pNum(h) * pNum(cS) : 0)
                            regularHours = regularHours + (!isNaN(pNum(h)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(cS) : 0)
                            regularTime = regularTime + (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0)
                            //if (job == '54025036' && h) { console.log('inside', regularTime) }
                        }
                    })

                    let labor = 0
                    let materials = 0
                    let equipment = 0
                    let rentals = 0
                    let subcontractors = 0
                    let other = 0
                    let contingency = 0
                    let total = 0

                    etcValues[job] && Object.keys(etcValues[job]).forEach((row) => {
                        etc = etc + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        //if(job == '54024086') console.log(etcValues[job][row][0], job, row, labor, rentals, materials, subcontractors, other);
                        if (row[0] == '5' && row[1] == '1' && (row[2] == '6' || row[2] == '7' || row[2] == '8')) {
                            labor = labor + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '2') {
                            rentals = rentals + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '3') {
                            materials = materials + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '4') {
                            subcontractors = subcontractors + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && (row[1] == '5' || row[1] == '6' || row[1] == '7')) {
                            other = other + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        }
                    })

                    let totalcLabor = 0
                    let totalcEquipment = 0
                    let totalcMaterials = 0
                    let totalcSubcontractors = 0
                    let totalcOtherExpenses = 0
                    let totalcTotal = 0

                    contingencyPieces[job] = {
                        '51100': {
                            '101101': 0
                        },
                        '52100': {
                            '101101': 0
                        },
                        '53100': {
                            '101101': 0
                        },
                        '54200': {
                            '101101': 0
                        },
                        '57900': {
                            '101101': 0
                        }
                    }

                    contingData[job] && Object.values(contingData[job]).forEach((row) => {
                        totalcLabor = totalcLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        contingencyPieces[job]['51100']['101101'] = contingencyPieces[job]['51100']['101101'] + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        totalcEquipment = totalcEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        contingencyPieces[job]['52100']['101101'] = contingencyPieces[job]['52100']['101101'] + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        totalcMaterials = totalcMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        contingencyPieces[job]['53100']['101101'] = contingencyPieces[job]['53100']['101101'] + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        totalcSubcontractors = totalcSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        contingencyPieces[job]['54200']['101101'] = contingencyPieces[job]['54200']['101101'] + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        totalcOtherExpenses = totalcOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                        contingencyPieces[job]['57900']['101101'] = contingencyPieces[job]['57900']['101101'] + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                    })
                    totalcTotal = totalcLabor + totalcEquipment + totalcMaterials + totalcSubcontractors + totalcOtherExpenses

                    //totalCost[job] = equipmentETC + regularTime + etc + totalcTotal
                    hours[job] = regularHours
                    etcLabor[job] = labor + regularTimeCostType + regularTime
                    etcLaborTwo[job] = regularTimeCostType
                    etcIncentive[job] = labor
                    etcEquipment[job] = equipmentCostType
                    etcMaterials[job] = materials
                    etcRentals[job] = rentals
                    etcSubcontractors[job] = subcontractors
                    etcOther[job] = other
                    etcContingency[job] = totalcTotal
                    totalContingency = totalContingency + totalcTotal
                    etcTotal[job] = labor + regularTimeCostType + equipmentCostType + materials + rentals + subcontractors + other + totalcTotal
                })
                console.log('etcLabor', etcLabor);

                //console.log('loading user data', etcValues, etcValuesPieces, phaseEtcValues, phaseEtcValuesPieces, etcLabor, etcLaborTwo, etcEquipment, etcMaterials, etcRentals, etcSubcontractors, etcOther, etcContingency, totalContingency, hours);
                setContingencyPieces(contingencyPieces)
                setHoursETC(hours)
                setLabor(etcLabor)
                setLaborCostType(etcLaborTwo)
                setEquipmentCostType(etcEquipment)
                setMaterials(etcMaterials)
                setRentals(etcRentals)
                setSubcontractors(etcSubcontractors)
                setOther(etcOther)
                setContingency(etcContingency)
                setTotalContingency(fNum(totalContingency, 1))
                setIncentive(etcIncentive)
                setTotal(etcTotal)
                setETC(etcTotal)

                //parts for projections
                setEtcPieces(etcValuesPieces)
                setPhaseEtcPieces(phaseEtcValuesPieces)
                setLaborPieces(laborCostTypePieces)
                setLaborPhasedPieces(regularTimePieces)
                setEquipmentPieces(equipmentCostTypePieces)


                let curBudget = {}
                let totalBudget = 0
                filteredJobs.forEach((job) => {
                    let jobCurBudget = 0
                    dayZeroValues[job.BU_ID] && Object.values(dayZeroValues[job.BU_ID]).forEach((row) => {
                        if (row['Cost_Type'] && row['Cost_Type'].length) {
                            if (row['Cost_Type'][0] == '4') {
                                jobCurBudget = jobCurBudget + pNum(row['Value_Amount'])
                            }
                        }
                    })

                    chOrValues[job.BU_ID] && Object.values(chOrValues[job.BU_ID]).forEach((row) => {
                        if (row.Status === 'Approved') {
                            jobCurBudget = jobCurBudget + (isNaN(pNum(row['41000'])) ? 0 : pNum(row['41000']))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.tAndM)) ? 0 : pNum(row.tAndM))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.changeOrders)) ? 0 : pNum(row.changeOrders))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.reductionOfScope)) ? 0 : pNum(row.reductionOfScope))
                        }
                    })
                    curBudget[job.BU_ID] = jobCurBudget > 0 ? fNum(jobCurBudget, 1) : ''
                    totalBudget = totalBudget + (jobCurBudget > 0 ? jobCurBudget : 0)
                })
                setCurBudget(curBudget)
                setTotalBudget(fNum(totalBudget, 1))
                setStartDates(startDates)
                setCompletionDates(completionDates)
                console.log('completionDates', completionDates)
                setMechCompleteDates(mechanicallyCompleteDates)
                setPhysicalComplete(physicalComplete)
            })

            Promise.all(jobChunks.map(chunk => loadTeamUserData({ ids: chunk, forecastGuid: selectedWIP?.Version_GUID }))).then((results) => {
                const data = results.flatMap(r => r?.data || [])
                let contData = {}
                let totalPrevContingency = 0
                //console.log('wip data', data);
                data.forEach((d) => {
                    if (d?.Forecast_Tab === 'Contingency') {
                        if (contData[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            contData[d?.BU_ID][d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else if (contData[d?.BU_ID]) {
                            contData[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        } else {
                            contData[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    [d.Forecast_Field_Name]: d.Forecast_Value
                                }
                            }
                        }
                    }
                })
                jobIds.forEach((job) => {
                    let totalLabor = 0
                    let totalEquipment = 0
                    let totalMaterials = 0
                    let totalSubcontractors = 0
                    let totalOtherExpenses = 0
                    contData[job] && Object.values(contData[job]).forEach((row) => {
                        totalLabor = totalLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        totalEquipment = totalEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        totalMaterials = totalMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        totalSubcontractors = totalSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        totalOtherExpenses = totalOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                    })
                    const totalcTotal = totalLabor + totalEquipment + totalMaterials + totalSubcontractors + totalOtherExpenses
                    contData[job] = totalcTotal
                    totalPrevContingency = totalPrevContingency + totalcTotal
                })
                setPrevContingency(contData)
                setTotalPrevContingency(fNum(totalPrevContingency, 1))
            })

            const jobIds1 = jobIds//.slice(0, 40)
            loadTeamCostDetailProjections({ ids: jobIds1, versions: [selectedVersion], wip: moment().add(1, 'month').format('YYYY-MM-DD') }).then((data) => {
                setProjectionCost(data?.data)
            })

            //const jobIds2 = jobIds.slice(40, jobIds.length)
            let actualCost = {}
            let actualCostPieces = {}
            let actualOverhead = {}
            let hours = {}
            let revenue = {}
            let revenuePrevPeriod = {}
            loadTeamCostDetail({ ids: jobIds1, forecastGuid: selectedVersion, wip: moment().add(1, 'month').format('YYYY-MM-DD') }).then((data) => {
                //console.log('cost detail', data);
                data?.data?.forEach((d) => {
                    if ((d?.Cost_Category == 'Job Cost - All Others' || d?.Cost_Category == 'Job Cost - Labor') && actualCost[d?.Job_Number]) {
                        actualCost[d?.Job_Number] = actualCost[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'Job Cost - All Others' || d?.Cost_Category == 'Job Cost - Labor') {
                        actualCost[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                    if (d?.Cost_Category == 'OH' && actualOverhead[d?.Job_Number]) {
                        actualOverhead[d?.Job_Number] = actualOverhead[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'OH') {
                        actualOverhead[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                    if (d?.Cost_Category == 'Job Cost - Labor' && hours[d?.Job_Number]) {
                        hours[d?.Job_Number] = hours[d?.Job_Number] + (isNaN(pNum(d?.Total_Hours)) ? 0 : pNum(d?.Total_Hours))
                    } else if (d?.Cost_Category == 'Job Cost - Labor') {
                        hours[d?.Job_Number] = (isNaN(pNum(d?.Total_Hours)) ? 0 : pNum(d?.Total_Hours))
                    }

                    if (d?.Cost_Category == 'Revenue' && revenue[d?.Job_Number]) {
                        revenue[d?.Job_Number] = revenue[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'Revenue') {
                        revenue[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                })
                //setEarnedRevenue(revenue)
                //console.log( 'actualCost', actualCost);
                setActualHours(hours)
                setActualCost(actualCost)
                console.log('setting actual overhead', actualOverhead);
                setActualOverhead(actualOverhead)
            })

            const wipDate = selectedWIP?.Version_Start_DateTime ? moment(selectedWIP?.Version_Start_DateTime).endOf('month').format('YYYY-MM-DD') : ''
            loadTeamCostDetail({ ids: jobIds1, forecastGuid: selectedVersion, wip: wipDate }).then((data) => {
                data?.data?.forEach((d) => {
                    if (d?.Cost_Category == 'Revenue') {
                        revenuePrevPeriod[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }
                })
                //console.log('earned rev rows', revenuePrevPeriod, wipDate, data?.data);
                setEarnedRevenueRows(revenuePrevPeriod)
            })

            let openCommitments = {}
            let openCommitmentsPieces = {}
            let openCommitmentsBreakout = {}
            loadTeamOpemCommitments({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                data?.data?.forEach((d) => {
                    if (d?.Cost_Type_Code?.[0] == '5' && openCommitments[d?.Job_Number]) {
                        openCommitments[d?.Job_Number] = openCommitments[d?.Job_Number] + (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                    } else if (d?.Cost_Type_Code?.[0] == '5') {
                        openCommitments[d?.Job_Number] = (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                    }

                    const costCode = d.Cost_Code ? d.Cost_Code : '100105'
                    if (!openCommitmentsPieces[d?.Job_Number]) {
                        openCommitmentsPieces[d?.Job_Number] = {}
                    }
                    if (!openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code]) {
                        openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code] = {}
                    }
                    if (!openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode]) {
                        openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode] = 0
                    }
                    openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode] = openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode] + (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                })
                //console.log( 'openCommitments', openCommitments, data?.data);
                setOpenCommitments(openCommitments)
                setOpenCommitmentsPieces(openCommitmentsPieces)
            })

            loadTeamBillings({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                let mostRecent = {}
                const billingData = {}
                const billings = {}
                data?.data?.forEach((d) => {
                    if (billingData[d?.Job_Number]) {
                        billingData[d?.Job_Number].push(d)
                    } else {
                        billingData[d?.Job_Number] = [d]
                    }
                })


                Object.values(billingData).forEach((bills) => {
                    let mostRecentCostDate = '2021-01-01'
                    let invoices = 0
                    bills.forEach((d) => {
                        if (d?.GL_Date && moment(d?.GL_Date).isAfter(moment(mostRecentCostDate))) {
                            mostRecentCostDate = moment(d?.GL_Date).format('M/D/YYYY')
                        }
                        invoices = invoices + pNum(d?.Invoice_Amount)
                    })
                    mostRecent[bills[0]?.Job_Number] = mostRecentCostDate
                    billings[bills[0]?.Job_Number] = invoices
                })
                setMostRecentBill(mostRecent)
                setBillings(billings)
            })

            //jobIds && jobIds.forEach((job, index) => {
            loadSummaryWIPArray({ ids: jobIds, wip: wipDate }).then((data) => {
                //if (index == 10) console.log('prevWIP', data);
                //console.log('prevWIP', data);
                let rev = {}
                let cost = {}
                let oh = {}
                let w = {}
                data?.data.forEach((d) => {
                    if (d?.Account_Category === 'Revenue' && rev[d?.BU_ID]) {
                        rev[d.BU_ID] = rev[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Revenue') {
                        rev[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Job Cost' && cost[d?.BU_ID]) {
                        cost[d.BU_ID] = cost[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Job Cost') {
                        cost[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'OH' && oh[d?.BU_ID]) {
                        oh[d.BU_ID] = oh[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'OH') {
                        oh[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    }
                })
                //console.log('prevWIP', wipDate, rev, cost, oh);
                //if (job == '50223020') console.log('prevWIP', wipDate, job, rev, cost, oh);
                jobIds.forEach((job) => {
                    w[job] = {
                        revenue: rev[job],
                        cost: cost[job],
                        overhead: oh[job],
                        total: -rev[job] - cost[job],
                        percent: rev[job] ? fNum((-rev[job] - cost[job]) / -rev[job] * 100) : ''
                    }
                })
                setJobPrevWIP(w)
            })
        }

    }, [filteredJobs])

    useEffect(() => {
        const phasedEquipmentCost = {}
        const equipmentRates = {}
        const equipmentPieces = {}
        const jobIds = filteredJobs.map(j => j.BU_ID)
        jobIds.forEach((job) => {
            equipmentUserData[job] && Object.keys(equipmentUserData[job]).forEach((row) => {
                if (equipmentUserData[job]?.[row]?.weekPerUnit) {
                    equipmentRates[equipmentUserData[job][row].equipment] = equipmentUserData[job][row].weekPerUnit
                }
            })
        })

        //console.log('equipRates', equipmentUserData, equipmentRates);

        jobIds.forEach((job) => {
            let equipmentETC = 0
            equipmentUserData[job] && Object.keys(equipmentUserData[job]).forEach((t) => {
                const r = equipmentUserData[job][t]
                const pC = completionDates[job]
                const v = versionInfo?.Version_Start_DateTime

                // Row IDs use '=' (new) or '*' (legacy) between name and week
                const _sep = t.includes('=') ? '=' : '*'
                const _idx = t.lastIndexOf(_sep)
                const w = _idx >= 0 ? t.substring(_idx + 1) : undefined
                const e = _idx >= 0 ? t.substring(0, _idx) : t
                const rate = r?.Rate
                const h = r?.Number_Hours
                const n = r?.Number_Units
                //console.log('e0', e, w, '-', h, '---', n, rate, moment(w).isAfter(moment(v).startOf('week')), moment(w).isBefore(pC))
                if (w && h && n && rate && moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(pC)) {//moment(w).endOf('week').isBefore(pC)) {
                    //if(job == '54025035')console.log('e1', job, r, (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0))
                    if (!equipmentPieces[job]) {
                        equipmentPieces[job] = {
                            '52100': {
                                [r.phaseCode]: 0
                            }
                        }
                    }
                    if (!equipmentPieces[job]['52100'][r.phaseCode]) {
                        equipmentPieces[job]['52100'][r.phaseCode] = 0
                    }
                    equipmentPieces[job]['52100'][r.phaseCode] = equipmentPieces[job]['52100'][r.phaseCode] + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)
                    if (job == '54025035') console.log('e2', e, job, w, rate, equipRates[e], equipmentRates[e], equipmentETC, (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0))
                    equipmentETC = equipmentETC + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)

                }
            })
            //if (equipmentETC) console.log( 'e3', job, equipmentETC)
            phasedEquipmentCost[job] = equipmentETC

        })
        //console.log('equipmentPhasedPieces--', equipmentPieces);
        //console.log( 'phasedEquipmentCost', phasedEquipmentCost);
        setEquipmentPhased(phasedEquipmentCost)
        setEquipmentPhasedPieces(equipmentPieces)
    }, [equipmentUserData, equipRates, completionDates, filteredJobs])

    useEffect(() => {
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const etc = {}
        jobIds.forEach((job) => {
            let etcTotal = labor[job] + materials[job] + rentals[job] + subcontractors[job] + other[job] + equipmentPhased[job] + equipmentCostType[job] + contingency[job]
            etc[job] = etcTotal
        })
        setETC(etc)
        setTotal(etc)
    }, [equipmentPhased, equipmentCostType, contingency])

    useEffect(() => {
        let EAC = {}
        let totalEAC = 0
        let jobProfit = {}
        let totalProfit = 0
        let jobProfitPerc = {}
        let jobGrossMargin = {}
        let totalGrossMargin = 0
        let jobGrossMarginPerc = {}
        let backlog = {}
        let totalBacklog = 0
        let costPercent = {}
        let earnedRevenue = {}
        //console.log('first', curBudget[filteredJobs[7]?.BU_ID], 'a', openCommitments[filteredJobs[7]?.BU_ID], ETC[filteredJobs[7]?.BU_ID], actualCost[filteredJobs[7]?.BU_ID])
        filteredJobs.forEach((job, index) => {
            const total = (pNum(actualCost[job.BU_ID]) + pNum(openCommitments[job.BU_ID]) + pNum(ETC[job.BU_ID]))
            EAC[job.BU_ID] = total > 0 ? fNum(total, 1) : ''
            totalEAC = totalEAC + (total > 0 ? total : 0)
            //if(index == 7) console.log('second', total, 'b', curBudget[job.BU_ID])
            jobProfit[job.BU_ID] = total > 0 && curBudget[job.BU_ID] ? fNum(pNum(curBudget[job.BU_ID]) - total, 1) : ''
            totalProfit = totalProfit + (jobProfit[job.BU_ID] ? pNum(jobProfit[job.BU_ID]) : 0)
            jobProfitPerc[job.BU_ID] = jobProfit[job.BU_ID] ? fNum(pNum(jobProfit[job.BU_ID]) / pNum(curBudget[job.BU_ID]) * 100) : ''

            //if (job.BU_ID == '50224024')console.log('job profit', curBudget[job.BU_ID], total, actualOverhead, actualOverhead[job.BU_ID], etcOverhead[job.BU_ID])
            const grossMargin = (pNum(curBudget[job.BU_ID]) - total - (isNaN(pNum(actualOverhead[job.BU_ID])) ? 0 : pNum(actualOverhead[job.BU_ID]))) - (isNaN(pNum(etcOverhead[job.BU_ID])) ? 0 : pNum(etcOverhead[job.BU_ID]))
            totalGrossMargin = totalGrossMargin + grossMargin
            const grossMarginPerc = grossMargin && curBudget[job.BU_ID] ? fNum(grossMargin / pNum(curBudget[job.BU_ID]) * 100) : ''
            jobGrossMargin[job.BU_ID] = grossMargin
            jobGrossMarginPerc[job.BU_ID] = grossMarginPerc

            backlog[job.BU_ID] = (1 - (pNum(actualCost[job.BU_ID]) / total)) * pNum(curBudget[job.BU_ID])
            totalBacklog = totalBacklog + (backlog[job.BU_ID] ? pNum(backlog[job.BU_ID]) : 0)
            costPercent[job.BU_ID] = total ? (pNum(actualCost[job.BU_ID]) / total) * 100 : ''
            earnedRevenue[job.BU_ID] = (costPercent[job.BU_ID] / 100) * pNum(curBudget[job.BU_ID])
        })
        // console.log('job profit', jobProfit)
        setEAC(EAC)
        setTotalEAC(fNum(totalEAC, 1))
        setJobProfit(jobProfit)
        setTotalJobProfit(fNum(totalProfit, 1))
        setJobProfitPerc(jobProfitPerc)
        setTotalJobProfitPercent(fNum(totalProfit / pNum(totalBudget) * 100, 2) + '%')
        setGrossMargin(jobGrossMargin)
        setTotalGrossMargin(fNum(totalGrossMargin, 1))
        setGrossMarginPerc(jobGrossMarginPerc)
        setTotalGrossMarginPercent(fNum(totalGrossMargin / pNum(totalBudget) * 100, 2) + '%')
        setBacklog(backlog)
        setTotalBacklog(fNum(totalBacklog, 1))
        setCostPercent(costPercent)
        setEarnedRevenue(earnedRevenue)

    }, [openCommitments, actualCost, ETC, curBudget, totalBudget])


    useEffect(() => {
        let jobs = [];
        let uniqueCombinations = new Map();

        const addToTotals = (jobId, costType, phaseCode, value, source) => {
            if (costType?.startsWith("51800") && source !== "actuals" && source !== "openCommitments") {
                phaseCode = "100105";
            }

            if (costType === "52400" && phaseCode === "100105") {
                phaseCode = "100102";
            }

            if (costType === "54200" && phaseCode === "100105") {
                phaseCode = "100101";
            }

            // If costType is 51100 or 52100 and phaseCode is undefined, set to 100105
            if ((costType === "51100" || costType === "52100") && (!phaseCode || phaseCode == 'undefined') && source !== "actuals" && source !== "openCommitments") {
                phaseCode = "100105";
            }

            if (phaseCode && phaseCode.includes('^')) {
                phaseCode = '100105'
            }

            const key = `${jobId}-${costType}-${phaseCode}`;

            if (uniqueCombinations.has(key)) {
                // If already exists, sum the value
                uniqueCombinations.set(key, value ? uniqueCombinations.get(key) + value : uniqueCombinations.get(key));
            } else {
                // Otherwise, store the new value
                uniqueCombinations.set(key, value);
            }
        };

        const processDataset = (dataset, source) => {
            Object.keys(dataset).forEach((jobId) => {
                const job = dataset[jobId];
                Object.keys(job).forEach((costType) => {
                    Object.keys(job[costType]).forEach((phaseCode) => {
                        addToTotals(jobId, costType, phaseCode, pNum(job[costType][phaseCode]), source);
                    });
                });
            });
        };


        //console.log('opencommitmentsPieces', openCommitmentsPieces);
        //console.log('laborPieces', laborPieces);
        //console.log('laborPhasedPieces', laborPhasedPieces);
        //console.log('equipmentCostTypePieces', equipmentPieces);
        //console.log('equipmentPhasedPieces', equipmentPhasedPieces);
        //console.log('contingencyPieces', contingencyPieces);
        //console.log('etcPieces', etcPieces);
        //console.log('projectionCost', projectionCost);
        console.log('labor cost', laborPieces);
        console.log('equipment cost', equipmentPieces);
        // Process all datasets
        processDataset(openCommitmentsPieces, "openCommitments");
        processDataset(laborPieces, "labor");
        processDataset(laborPhasedPieces, "laborPhased");
        processDataset(equipmentPieces, "equipment");
        processDataset(equipmentPhasedPieces, "equipmentPhased");
        processDataset(contingencyPieces, "contingency");
        processDataset(etcPieces, "etc");
        //processDataset(projectionCost, "actuals");

        // Process projection costs separately
        projectionCost && projectionCost.forEach((job, index) => {
            //if (index == 0) console.log('projectionCost', job);
            addToTotals(job.Job_Number, job.Cost_Type_Code, job.Phase_Code, pNum(job.Total_Job_Cost), "actuals");
        });

        const tierSize = {}
        filteredJobs.forEach((job) => {
            if (job?.BU_ID) {
                tierSize[job.BU_ID] = job?.Cat_Code_BU_16
            }
        });
        const finalData = Array.from(uniqueCombinations, ([key, value]) => {
            const [jobId, costType, phaseCode] = key.split("-");
            return { jobId, costType, phaseCode, value: fNum(value), tier: tierSize[jobId] };
        });

        filteredJobs.forEach((job) => {
            finalData.push({
                jobId: job.BU_ID,
                costType: '41000',
                phaseCode: '990000',
                value: curBudget[job.BU_ID] ? '-' + curBudget[job.BU_ID] : 0
            })

            finalData.push({
                jobId: job.BU_ID,
                costType: '60900',
                phaseCode: '1000',
                value: actualOverhead[job.BU_ID] && etcOverhead[job.BU_ID] ? pNum(actualOverhead[job.BU_ID]) + pNum(etcOverhead[job.BU_ID]) : actualOverhead[job.BU_ID] ? actualOverhead[job.BU_ID] : etcOverhead[job.BU_ID] ? etcOverhead[job.BU_ID] : 0
            })
        })

        //console.log("Summed Job-CostType-PhaseCode Combinations:", finalData, actualOverhead, etcOverhead);

        setProjectionRows(finalData);
    }, [filteredJobs, openCommitmentsPieces, projectionCost, equipmentPieces, equipmentPhasedPieces, actualOverhead]);

    const uploadTest = async () => {
        console.log('uploadProjections test', neededProjections);
        //const jdeJobIds = jdeValues.map(d => d.Job_ID.trim());
        //const first20Items = neededProjections.filter(row => jdeJobIds.includes(row.jobId));
        //console.log(first20Items);//, '54025029', '54025030', '54025031', '54025032', '54025033', '54025034', '54025037', '54025038', '54025039'
        const first20Items = neededProjections.filter(row => ['54025028'].includes(row.jobId));
        console.log(first20Items);
        for (const row of first20Items) {
            try {
                if (first20Items.indexOf(row) % 10 === 0) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }
                const response = fetch('https://jdeorchtest.strikeusa.com:443/jderest/orchestrator/STR_ORCH_UploadFusionEAC', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic MTQ4Njk0OlV4ZTBUbWotV1Q5OGJGQXE='
                    },
                    // const response = fetch('https://jdeorch.strikeusa.com:443/jderest/orchestrator/STR_ORCH_UploadFusionEAC', {
                    //     method: 'POST',
                    //     headers: {
                    //         'Content-Type': 'application/json',
                    //         'Authorization': 'Basic MTQ4Njk1Oks2b1chKmVJZ216dDZWd2Y='
                    //     },
                    body: JSON.stringify({
                        "inORCH_AccountNbr": row.jobId + '.' + row.costType + '.' + row.phaseCode,
                        "inORCH_User": "154045",
                        "inORCH_Remark": "Sept WIP Fusion Upload",
                        "inORCH_EACAmount": pNum(row.value),
                        "inORCH_GLDate": "2/28/2025",
                        "inORCH_FY": "25"
                    })
                })
                    .then(response => response.json())
                    .then((data) => {
                        if (data?.jde__status !== "SUCCESS") {
                            // Save the data to the user table and local state
                            const failedData = {
                                jobId: row.jobId,
                                costType: row.costType,
                                phaseCode: row.phaseCode,
                                value: row.value,
                                message: JSON.stringify(data?.message)
                            };

                            let dataToSave = {
                                userId: '154045',
                                userName: 'Seth Bailey',
                                fieldName: 'failedUpload',
                                tab: "Projections",
                                rowId: row.jobId + '.' + row.costType + '.' + row.phaseCode,
                                version: selectedVersion + '',
                                value: JSON.stringify(data?.message),
                                id: row.jobId,
                                lockedVersion: lockedVersion
                            };
                            updateUserDataArray(dataToSave);

                            // Update local state to reflect the failed data
                            setFailedUploads((prevFailedUploads) => [...prevFailedUploads, failedData]);
                        }
                        //console.log('Response Status:', response.status);
                        //console.log('Response Data:', data);
                    }).catch((err) => {
                        console.log('Error making API call:', err.message);
                        const failedData = {
                            jobId: row.jobId,
                            costType: row.costType,
                            phaseCode: row.phaseCode,
                            value: row.value,
                            message: JSON.stringify(data.message)
                        };

                        let data = {
                            userId: '154045',
                            userName: 'Seth Bailey',
                            fieldName: 'failedUpload',
                            tab: "Projections",
                            rowId: row.jobId + '.' + row.costType + '.' + row.phaseCode,
                            version: selectedVersion + '',
                            value: JSON.stringify(data.message),
                            id: row.jobId,
                            lockedVersion: lockedVersion
                        };
                        updateUserDataArray(data);

                        // Update local state to reflect the failed data
                        setFailedUploads((prevFailedUploads) => [...prevFailedUploads, failedData]);
                    })
            } catch (error) {
                console.error('Error:', error);
            }
        }
        console.log('end')
    };

    const uploadProjections = () => {
        console.log('uploadProjections', excelProjectionRows);
        for (const row of excelProjectionRows) {
            try {
                const response = fetch('https://jdeorch.strikeusa.com:443/jderest/orchestrator/STR_ORCH_UploadFusionEAC', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic MTQ4Njk1Oks2b1chKmVJZ216dDZWd2Y='
                    },
                    body: JSON.stringify({
                        "inORCH_AccountNbr": row.jobId + '.' + row.costType + '.' + row.phaseCode,
                        "inORCH_User": "154045",
                        "inORCH_Remark": "Jan WIP Fusion Upload",
                        "inORCH_EACAmount": row.value,
                        "inORCH_GLDate": "01/31/2025",
                        "inORCH_FY": "25"
                    })
                })
                    .then(response => response.json())
                    .then((data) => {
                        if (data?.jde__status !== "SUCCESS") {
                            // Save the data to the user table and local state
                            const failedData = {
                                jobId: row.jobId,
                                costType: row.costType,
                                phaseCode: row.phaseCode,
                                value: row.value,
                                message: JSON.stringify(data?.message)
                            };

                            let dataToSave = {
                                userId: '154045',
                                userName: 'Seth Bailey',
                                fieldName: 'failedUpload',
                                tab: "Projections",
                                rowId: row.jobId + '.' + row.costType + '.' + row.phaseCode,
                                version: selectedVersion + '',
                                value: JSON.stringify(data?.message),
                                id: row.jobId,
                                lockedVersion: lockedVersion
                            };
                            updateUserDataArray(dataToSave);

                            // Update local state to reflect the failed data
                            setFailedUploads((prevFailedUploads) => [...prevFailedUploads, failedData]);
                        }
                        //console.log('Response Status:', response.status);
                        //console.log('Response Data:', data);
                    }).catch((err) => {
                        console.log('Error making API call:', err.message);
                        const failedData = {
                            jobId: row.jobId,
                            costType: row.costType,
                            phaseCode: row.phaseCode,
                            value: row.value,
                            message: JSON.stringify(data.message)
                        };

                        let data = {
                            userId: '154045',
                            userName: 'Seth Bailey',
                            fieldName: 'failedUpload',
                            tab: "Projections",
                            rowId: row.jobId + '.' + row.costType + '.' + row.phaseCode,
                            version: selectedVersion + '',
                            value: JSON.stringify(data.message),
                            id: row.jobId,
                            lockedVersion: lockedVersion
                        };
                        updateUserDataArray(data);

                        // Update local state to reflect the failed data
                        setFailedUploads((prevFailedUploads) => [...prevFailedUploads, failedData]);
                    })
            } catch (error) {
                console.error('Error:', error);
            }
        }
        console.log('end')
    };

    useEffect(() => {
        let jobs = []
        let details = {}
        let totals = { open: {}, actual: {}, etc: {}, fieldBonus: {}, rentals: {}, materials: {}, subcontractors: {}, other: {}, contingency: {}, laborCostType: {}, laborPhased: {}, equipmentCostType: {}, equipmentPhased: {}, etc: {} }

        Object.keys(openCommitmentsPieces).forEach((id) => {
            const job = openCommitmentsPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.open[id] = jobTotal
        })

        Object.keys(laborPieces).forEach((id) => {
            const job = laborPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.laborCostType[id] = jobTotal
        })

        Object.keys(laborPhasedPieces).forEach((id) => {
            const job = laborPhasedPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.laborPhased[id] = jobTotal
        })

        Object.keys(equipmentPieces).forEach((id) => {
            const job = equipmentPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.equipmentCostType[id] = jobTotal
        })

        Object.keys(equipmentPhasedPieces).forEach((id) => {
            const job = equipmentPhasedPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.equipmentPhased[id] = jobTotal
        })


        projectionCost && projectionCost.forEach((job) => {
            if (!totals.actual[job.Job_Number]) {
                totals.actual[job.Job_Number] = 0
            }
            totals.actual[job.Job_Number] = totals.actual[job.Job_Number] + pNum(job.Total_Job_Cost)
        })

        Object.keys(contingencyPieces).forEach((id) => {
            const job = contingencyPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.contingency[id] = jobTotal
        })

        Object.keys(etcPieces).forEach((id) => {
            const job = etcPieces[id]
            let jobTotal = 0
            let fieldBonus = 0
            let rentals = 0
            let materials = 0
            let subcontractors = 0
            let other = 0
            Object.keys(job).forEach((costTypeId) => {
                const costType = job[costTypeId]
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                    if (costTypeId[0] == '5' && costTypeId[1] == '1' && costTypeId[2] == '8') {
                        fieldBonus = fieldBonus + pNum(code)
                    } if (costTypeId[0] == '5' && costTypeId[1] == '2') {
                        rentals = rentals + pNum(code)
                    } else if (costTypeId[0] == '5' && costTypeId[1] == '3') {
                        materials = materials + pNum(code)
                    } else if (costTypeId[0] == '5' && costTypeId[1] == '4') {
                        subcontractors = subcontractors + pNum(code)
                    } else if (costTypeId[0] == '5' && (costTypeId[1] == '5' || costTypeId[1] == '6' || costTypeId[1] == '7')) {
                        other = other + pNum(code)
                    }
                })
            })
            totals.fieldBonus[id] = fieldBonus
            totals.rentals[id] = rentals
            totals.materials[id] = materials
            totals.subcontractors[id] = subcontractors
            totals.other[id] = other
        })

        filteredJobs.forEach((job, index) => {
            const data = {
                id: job.BU_ID,
                fieldBonus: totals.fieldBonus?.[job.BU_ID] ? fNum(totals.fieldBonus[job.BU_ID]) : 0,
                rentals: totals.rentals?.[job.BU_ID] ? fNum(totals.rentals[job.BU_ID]) : 0,
                materials: totals.materials?.[job.BU_ID] ? fNum(totals.materials[job.BU_ID]) : 0,
                subcontractors: totals.subcontractors?.[job.BU_ID] ? fNum(totals.subcontractors[job.BU_ID]) : 0,
                other: totals.other?.[job.BU_ID] ? fNum(totals.other[job.BU_ID]) : 0,
                etc: totals.etc?.[job.BU_ID] ? fNum(totals.etc[job.BU_ID]) : 0,
                cost: totals.actual?.[job.BU_ID] ? fNum(totals.actual[job.BU_ID]) : 0,
                open: totals.open?.[job.BU_ID] ? fNum(totals.open[job.BU_ID]) : 0,
                contingency: totals.contingency?.[job.BU_ID] ? fNum(totals.contingency[job.BU_ID]) : 0,
                laborCostType: totals.laborCostType?.[job.BU_ID] ? fNum(totals.laborCostType[job.BU_ID]) : 0,
                laborPhased: totals.laborPhased?.[job.BU_ID] ? fNum(totals.laborPhased[job.BU_ID]) : 0,
                equipmentCostType: totals.equipmentCostType?.[job.BU_ID] ? fNum(totals.equipmentCostType[job.BU_ID]) : 0,
                equipmentPhased: totals.equipmentPhased?.[job.BU_ID] ? fNum(totals.equipmentPhased[job.BU_ID]) : 0,
                total: 0
            }

            jobs.push(data)
        })

        console.log('proj', equipmentPhasedPieces)
        setProjectionDetails(jobs)
    }, [filteredJobs, openCommitmentsPieces, projectionCost, equipmentPieces, equipmentPhasedPieces])

    useEffect(() => {
        let totalJobPerformanceChange = 0
        let totalPrevWIP = 0
        filteredJobs.forEach((job) => {
            const jobPerformanceChange = jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]) : 0
            const prevWIP = jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) : 0
            totalJobPerformanceChange = totalJobPerformanceChange + jobPerformanceChange
            totalPrevWIP = totalPrevWIP + prevWIP
        })
        setTotalJobPerformanceChange(fNum(totalJobPerformanceChange, 1))
        setTotalPrevWIP(fNum(totalPrevWIP, 1))
    }, [jobProfit, jobPrevWIP, contingency, prevContingency])

    const divideIntoSections = (logs) => {
        let sections = [];
        const sectionSize = 31;
        //console.log('logs', logs, sectionSize)
        for (let i = 0; i < logs.length; i += sectionSize) {
            //console.log('adding section', logs.slice(i, i + sectionSize))
            sections.push(logs.slice(i, i + sectionSize));
        }
        //console.log('summary sections', sections)
        return sections;
    }

    useEffect(() => {
        const sortedBacklog = filteredJobs.sort((a, b) => {
            const backlogA = backlog[a.BU_ID] || 0;
            const backlogB = backlog[b.BU_ID] || 0;

            return backlogB - backlogA; // Sort descending
        });
        setBacklogFiltered(sortedBacklog);
        //console.log('sortedBacklog', divideIntoSections(sortedBacklog))
        setBacklogFilteredImage(divideIntoSections(sortedBacklog))
    }, [filteredJobs, backlog])

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions, selectedVersion]);

    useEffect(() => {
        let filtered = []
        console.log('jobs', jobs)
        filtered = jobs ? jobs.filter(a => a.Cat_Code_BU_27 == selectedTeam).filter(a => a.Cat_Code_BU_08 != 'T&M') : []
        if (adminButton) {
            filtered = jobs ? jobs.filter(a => a.Cat_Code_BU_08 != 'T&M') : []
            setFetchedAllJobUserData(false)
        }
        const jobIdsString = filtered.map(job => job.BU_ID).join(', ');
        console.log(jobIdsString);
        setFilteredJobs(filtered)
    }, [jobs, adminButton])

    const s = StyleSheet.create({
        cell: {
            height: 20,
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 2,
            lineHeight: 16,
            textWrap: 'nowrap',
            overflow: 'hidden',
            textAlign: 'right'
        },
        cellt: {
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 2,
            paddingBottom: 3,
            textAlign: 'right',
            fontSize: 12
        },
        celll: {
            height: 20,
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 2,
            textWrap: 'nowrap',
            overflow: 'hidden',
            textAlign: 'left',
            fontSize: 12
        }
    });

    useEffect(() => {
        if (photo) {
            backlogFilteredImage.forEach((_, index) => {
                if (!sectionRefs.current[index]) {
                    sectionRefs.current[index] = React.createRef();
                }
            });
            setJobRef(job, 'summary', sectionRefs.current)
        }
    }, [backlogFilteredImage]);

    const Row = ({ job }) => {
        const [highlighted, setHighlighted] = useState(highlightedJob[job.BU_ID] || false)

        const saveValue = (value) => {
            let data = {
                userId: '154045',
                userName: 'Seth Bailey',
                fieldName: 'highlighted',
                tab: "Summary",
                rowId: job.BU_ID,
                version: selectedVersion + '',
                value: value + '',
                id: job.BU_ID,
                lockedVersion: lockedVersion
            }
            console.log('saving data', data)
            updateUserDataArray(data)
        }

        return (
            <View>
                {((photoLocal && (curBudget[job.BU_ID] || EAC[job.BU_ID])) || !photoLocal) ? <Pressable
                    onPress={() => {
                        if (!highlighted) {
                            setHighlighted('first')
                            saveValue('first')
                        } else if (highlighted == 'first') {
                            setHighlighted('second')
                            saveValue('second')
                        } else {
                            setHighlighted(false)
                            saveValue('false')
                        }
                    }}
                    style={{ flexDirection: 'row', paddingLeft: 10, paddingBottom: 0, backgroundColor: highlighted == 'first' ? '#ffe699' : highlighted == 'second' ? '#d9d9d9' : '' }}>
                    {photoLocal ? null : <Text style={[s.celll, { width: 70 }]}>{job.BU_ID}</Text>}
                    <Text style={[s.celll, { width: 40 }]}>{job.Cat_Code_BU_08 == 'TMN' ? 'NTE' : job.Cat_Code_BU_08}</Text>
                    <Text style={[s.celll, { width: 160 }]}>{job.BU_Description}</Text>
                    <Text style={[s.celll, { width: 100 }]}>{job.AR_AB_Name}</Text>
                    {/* {photoLocal ? null : <Text style={[s.celll, { width: 100 }]}>{job.Address_2_AB_Name}</Text>} */}
                    {expandCosts ? <View style={{ flexDirection: 'row' }}>
                        <View style={{ width: 5 }}></View>
                        <Text style={[s.cell, { width: 80 }]}>{actualCost[job.BU_ID] ? fNum(pNum(actualCost[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{openCommitments[job.BU_ID] ? fNum(pNum(openCommitments[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{labor[job.BU_ID] ? fNum(pNum(labor[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{laborCostType[job.BU_ID] ? fNum(pNum(laborCostType[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{equipmentCostType[job.BU_ID] || equipmentPhased[job.BU_ID] ? fNum(pNum(equipmentCostType[job.BU_ID]) + pNum(equipmentPhased[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{materials[job.BU_ID] ? fNum(pNum(materials[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{rentals[job.BU_ID] ? fNum(pNum(rentals[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{subcontractors[job.BU_ID] ? fNum(pNum(subcontractors[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{other[job.BU_ID] ? fNum(pNum(other[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{contingency[job.BU_ID] ? fNum(pNum(contingency[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{incentive[job.BU_ID] ? fNum(pNum(incentive[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{total[job.BU_ID] ? fNum(pNum(total[job.BU_ID]), 1) : ''}</Text>
                    </View> : null}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 80 }]}>{curBudget[job.BU_ID] ? fNum(pNum(curBudget[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80 }]}>{EAC[job.BU_ID] ? fNum(pNum(EAC[job.BU_ID]), 1) : ''}</Text>
                    {/* <Text style={[s.cell, { width: 80 }]}>{actualCost[job.BU_ID] ? fNum(pNum(actualCost[job.BU_ID]), 1) : ''}</Text>
                <Text style={[s.cell, { width: 80 }]}>{openCommitments[job.BU_ID] ? fNum(pNum(openCommitments[job.BU_ID]), 1) : ''}</Text>
                <Text style={[s.cell, { width: 80 }]}>{total[job.BU_ID] ? fNum(pNum(total[job.BU_ID]), 1) : ''}</Text> */}
                    <Text style={[s.cell, { width: 80 }]}>{jobProfit[job.BU_ID] ? fNum(pNum(jobProfit[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 60 }]}>{jobProfitPerc[job.BU_ID] ? fNum(pNum(jobProfitPerc[job.BU_ID]), 2) + '%' : ''}</Text>
                    {/* <Text style={[s.cell, { width: 80 }]}>{actualOverhead[job.BU_ID] ? fNum(pNum(actualOverhead[job.BU_ID]), 1) : ''}</Text> */}
                    {/* <Text style={[s.cell, { width: 80 }]}>{etcOverhead[job.BU_ID] ? fNum(pNum(etcOverhead[job.BU_ID]), 1) : ''}</Text> */}
                    <Text style={[s.cell, { width: 80 }]}>{grossMargin[job.BU_ID] ? fNum(pNum(grossMargin[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 60 }]}>{grossMarginPerc[job.BU_ID] ? fNum(pNum(grossMarginPerc[job.BU_ID]), 2) + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 80 }]}>{contingency[job.BU_ID] ? fNum(pNum(contingency[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80 }]}>{prevContingency[job.BU_ID] ? fNum(pNum(prevContingency[job.BU_ID]), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80 }]}>{backlog[job.BU_ID] ? fNum(pNum(backlog[job.BU_ID]), 1) : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 40 }]}>{costPercent[job.BU_ID] ? fNum(pNum(costPercent[job.BU_ID]), 1) + '%' : ''}</Text>
                    <Text style={[s.cell, { width: 40 }]}>{actualHours[job.BU_ID] ? fNum(100 * pNum(actualHours[job.BU_ID]) / (pNum(actualHours[job.BU_ID]) + pNum(hoursETC[job.BU_ID])), 1) + '%' : ''}</Text>
                    <Text style={[s.cell, { width: 40 }]}>{physicalComplete[job.BU_ID] ? physicalComplete[job.BU_ID] + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    {expandBills ? <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 80 }]}>{mostRecentBill[job.BU_ID] != '2021-01-01' ? mostRecentBill[job.BU_ID] : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{earnedRevenue[job.BU_ID] ? fNum(pNum(earnedRevenue[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{billings[job.BU_ID] ? fNum(pNum(billings[job.BU_ID]), 1) : ''}</Text>
                        <Text style={[s.cell, { width: 80 }]}>{remainingToBill[job.BU_ID] ? fNum(pNum(remainingToBill[job.BU_ID]), 1) : ''}</Text>
                    </View> : null}
                    <Text style={[s.cell, { width: 80 }]}>{overUnderBilled[job.BU_ID] ? fNum(pNum(overUnderBilled[job.BU_ID]), 1) : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 80 }]}>{jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]), 1) : ''}</Text>
                    {/* <Text style={[s.cell, { width: 80 }]}>{jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobPrevWIP[job.BU_ID]?.total), 1) : ''}</Text>
                <Text style={[s.cell, { width: 80 }]}>{jobPrevWIP[job.BU_ID]?.percent ? fNum(jobPrevWIP[job.BU_ID]?.percent) + '%' : ''}</Text> */}
                    <Text style={[s.cell, { width: 80 }]}>{jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? fNum(pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total), 1) : ''}</Text>
                    <Text style={[s.cell, { width: 80 }]}>{jobProfitPerc[job.BU_ID] && jobPrevWIP[job.BU_ID]?.percent ? fNum(pNum(jobProfitPerc[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.percent)) + '%' : ''}</Text>
                    {/* <View style={{ width: 20 }}></View>
                <Text style={[s.cell, { width: 80 }]}>{startDates[job.BU_ID]}</Text>
                <Text style={[s.cell, { width: 80 }]}>{mechCompleteDates[job.BU_ID]}</Text>
                <Text style={[s.cell, { width: 80 }]}>{completionDates[job.BU_ID]}</Text> */}
                </Pressable> : null}
            </View>
        )
    }

    const Header = () => {
        return (
            <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                {photoLocal ? null : <Text style={[s.cellt, { width: 70, backgroundColor: '#e0e0e0' }]}>Job Number</Text>}
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Work Type</Text>
                <Text style={[s.cellt, { width: 160, backgroundColor: '#e0e0e0' }]}>Job Name</Text>
                <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Client</Text>
                {/* {photoLocal ? null : <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Project Manager</Text>} */}
                {expandCosts ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Actual Cost</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Open Commit</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Labor</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Labor Cost Type</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Internal Equipment</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Materials</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Rentals/Fuel</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Subcontractors</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Other</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Contingency</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Incentive</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Total ETC</Text>
                </View> : null}
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>
                    <Icon
                        onPress={() => setExpandCosts(!expandCosts)}
                        name={expandCosts ? "chevron-small-down" : "chevron-small-right"}
                        size={20}
                    />
                    Cur Budget Revenue</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Est Cost At Completion</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Actual Cost</Text>
            <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Open Commit</Text>
            <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>ETC</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Job Profit</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>Job Profit %</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Overhead</Text>
            <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>ETC Overhead</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Gross Margin</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>Gross Margin %</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Current Contingency</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev WIP Contingency</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Backlog</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Costs</Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Labor Hours</Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}>Physical</Text>
                <View style={{ width: 5 }}></View>
                {expandBills ? <View style={{ flexDirection: 'row' }}>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Last Billing</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Earned Revenue</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Billings</Text>
                    <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Remaining to Bill</Text>
                </View> : null}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>
                    <Icon
                        onPress={() => setExpandBills(!expandBills)}
                        name={expandBills ? "chevron-small-down" : "chevron-small-right"}
                        size={20}
                    />
                    Over/Under Billed</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Job Performance Change</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev Job Profit</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev Job Profit %</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev. WIP Gain/Fade $</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Prev. WIP Gain/Fade %</Text>
                {/* <View style={{ width: 20 }}></View>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Start Date (Actual)</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Mechanically Complete Date</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>Completion Date (Forecasted)</Text> */}
            </View>
        )
    }

    const Footer = () => {
        return (
            <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                {photoLocal ? null : <Text style={[s.cellt, { width: 70, backgroundColor: '#e0e0e0' }]}></Text>}
                <Text style={[s.cellt, { width: 300, backgroundColor: '#e0e0e0' }]}></Text>
                {expandCosts ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ width: 960 }}></View>
                </View> : null}
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalBudget}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalEAC}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalJobProfit}</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>{totalJobProfitPercent}</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalGrossMargin}</Text>
                <Text style={[s.cellt, { width: 60, backgroundColor: '#e0e0e0' }]}>{totalGrossMarginPercent}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalContingency}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalPrevContingency}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalBacklog}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}></Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}></Text>
                <Text style={[s.cellt, { width: 40, backgroundColor: '#e0e0e0' }]}></Text>
                <View style={{ width: 5 }}></View>
                {expandBills ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ width: 320 }}></View>
                </View> : null}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalOverUnderBilled}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalJobPerformanceChange}</Text>
                {/* <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalPrevJobProfit}</Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalPrevJobProfitPerc}</Text> */}
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}>{totalPrevWIP}</Text>
                <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text>
                {/* <View style={{ width: 20 }}></View>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text>
        <Text style={[s.cellt, { width: 80, backgroundColor: '#e0e0e0' }]}></Text> */}
            </View>
        )
    }

    return (
        <View>
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', marginRight: 'auto' }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                    {versionInfo && versionInfo.Version_Start_DateTime &&
                        <View>
                            <View style={{ backgroundColor: isLiveVersion ? '#192440' : 'white', borderRadius: 5, justifyContent: 'center', padding: 10 }}>
                                <Text style={{ color: isLiveVersion ? 'white' : 'black' }}>
                                    {moment(versionInfo.Version_Start_DateTime).format('MMM D, YYYY')} {isLiveVersion ? '- Active' : ''}
                                </Text>
                            </View>
                        </View>
                    }
                    <Text style={{ fontSize: 16, paddingLeft: 30 }}>
                        {selectedTeam}
                    </Text>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            createExcel()
                        }}
                    >
                        <Icon2
                            name="file-download"
                            size={20}
                        />
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            setPhotoLocal(!photoLocal)
                        }}
                    >
                        <Text>Collapse Columns For PSR</Text>
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            setAdminButton(!adminButton)
                        }}
                    >
                        <Text>Load All Teams</Text>
                    </Pressable>
                </View>
            </View>
            <View style={{ flexDirection: 'row', marginBottom: 50 }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20, width: 200 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5, flexDirection: 'row' }}
                        onPress={() => {
                            fileInput.current.click();
                        }}
                    >
                        <Text>Upload Excel Projections</Text>
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20, width: 200 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={uploadProjections}
                    >
                        <Text>Save to JDE</Text>
                    </Pressable>
                </View>
                {/* <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20, width: 200 }}>
                        <Pressable
                            style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                            onPress={exportToExcel}
                        >
                            <Text>Export to Excel</Text>
                        </Pressable>
                    </View> */}
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20, width: 200 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={findCombinations}>
                        <Text>Check Combinations</Text>
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20, width: 200 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={exportCurrentValues}>
                        <Text>Export Projections Excel</Text>
                    </Pressable>
                </View>
                <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20, width: 200 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={uploadTest}
                    >
                        <Text>Save to JDE Test</Text>
                    </Pressable>
                </View>
                <input type="file" ref={fileInput}
                    style={{ display: 'none', height: 0, width: 0 }}
                    onChange={fileSelectedHandler} accept=".xlsx" />
            </View>
            <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 150, flexDirection: 'row' }}>
                <View ref={view}>
                    {photo && backlogFilteredImage ? backlogFilteredImage.map((summary, i) => (
                        <View ref={sectionRefs.current[i]}>
                            <Header />
                            {summary ? summary.map((job, i) => (
                                <Row key={i} job={job} />
                            )) : null}
                            <Footer />
                        </View>
                    )) :
                        <View ref={sectionRefs.current[0]}>
                            <Header />
                            {backlogFiltered.map((job, i) => (
                                <Row key={i} job={job} />
                            ))}
                            <Footer />
                        </View>
                    }
                </View>
            </View>
            <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 150 }}>
                <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Job Number</Text>
                    {/* <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5}}>Cost Type</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5}}>Phase</Text> */}
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Labor Cost Type</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Labor Phased</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Equipment Cost Type</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Equipment Phased</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Field Bonus</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Rentals</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Materials</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Subcontractors</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Other</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Contingency</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Actual Cost</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Open Commitments</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>ETC</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>EAC</Text>
                </View>
                {projectionDetails.map((row, i) => (
                    <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.id}</Text>
                        {/* <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5}}>{row.costType}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5}}>{row.phase}</Text> */}
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.laborCostType}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.laborPhased}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.equipmentCostType}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.equipmentPhased}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.fieldBonus}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.rentals}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.materials}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.subcontractors}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.other}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.contingency}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.cost}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.open}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.etc}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{row.total}</Text>
                    </View>
                ))}
            </View>
            <View style={{ backgroundColor: '#fff', justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                <Pressable
                    style={{ alignItems: 'center', padding: 10, borderRadius: 5, flexDirection: 'row' }}
                    onPress={() => setShowNotFoundList(!showNotFoundList)}
                >
                    <Icon2
                        name={showNotFoundList ? "expand-less" : "expand-more"}
                        size={20}
                    />
                    <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>Not Found in GL Account</Text>
                    <Text style={{ fontSize: 18, marginBottom: 10, marginLeft: 10 }}>{notFoundListCount}</Text>
                </Pressable>
                {showNotFoundList && (
                    <View style={{ margin: 20, backgroundColor: 'white', marginBottom: 50 }}>
                        <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Job ID</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Tier</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Cost Type</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Phase Code</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Value</Text>
                            <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5 }}>Message</Text>
                        </View>
                        {notFoundList.map((upload, i) => (
                            <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.jobId}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.tier}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.costType}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.phaseCode}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.value}</Text>
                                {/* <Dropdown
                                    style={{ width: 150, borderWidth: 1, borderRadius: 5, paddingHorizontal: 10, backgroundColor: '#fff' }}
                                    data={['100101']}
                                    labelField="label"
                                    valueField="value"
                                    value={upload.phaseCode}
                                    onChange={(selectedItem) => handlePhaseChange(index, selectedItem.value)}
                                    placeholder="Select Phase"
                                /> */}
                                <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5 }}>{upload.message}</Text>
                            </View>
                        ))}
                    </View>
                )}
            </View>
            <View style={{ backgroundColor: '#fff', justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                {false && highLevelCompareList && highLevelCompareList.length > 0 && (
                    <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 50 }}>
                        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>High Level Compare List</Text>
                        <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Job ID</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Labor</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Labor Projection</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Equipment</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Equipment Projection</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Materials</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Materials Projection</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Subcontractors</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Subcontractors Projection</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Other</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Other Projection</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Contingency</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Contingency Projection</Text>
                        </View>
                        {highLevelCompareList.map((item, i) => (
                            <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{item.jobId}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.labor)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.laborProjection)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.equipment)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.equipmentProjection)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.materials)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.materialsProjection)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.subcontractors)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.subcontractorsProjection)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.other)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.otherProjection)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.contingency)}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{fNum(item.contingencyProjection)}</Text>
                            </View>
                        ))}
                    </View>
                )}
                {false & compareList && compareList.length > 0 && (
                    <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 50 }}>
                        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>Compare List</Text>
                        <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Job ID</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Cost Type</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Phase Code</Text>
                            <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>JDE Value</Text>
                            <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5 }}>Projection Value</Text>
                        </View>
                        {compareList.map((upload, i) => (
                            <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.jobId}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.costType}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.phaseCode}</Text>
                                <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.value}</Text>
                                <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5, backgroundColor: upload.value != upload.projectionValue ? '#e0e0e0' : '' }}>{upload.projectionValue}</Text>
                            </View>
                        ))}
                    </View>
                )}
            </View>

            <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 150 }}>
                <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>Failed Uploads</Text>
                <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Job ID</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Cost Type</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Phase Code</Text>
                    <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>Value</Text>
                    <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5 }}>Message</Text>
                </View>
                {failedUploads.map((upload, i) => (
                    <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.jobId}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.costType}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.phaseCode}</Text>
                        <Text style={{ flex: 1, textAlign: 'center', paddingHorizontal: 5 }}>{upload.value}</Text>
                        <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5 }}>{upload.message}</Text>
                    </View>
                ))}
            </View>
        </View>
    );
}

export default RunProjections;

